import {BrowserRouter, Route, Routes} from 'react-router-dom'
import {routeArr} from './routes'
import MainLayout from './components/layouts/mainLayout'
import {useRef, useEffect, useState, Suspense} from 'react'
import {useSelector} from 'react-redux'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
import CustomerHelper from './utils/customer'
import TagManager from 'react-gtm-module'
import {clarity} from 'react-microsoft-clarity'
import localStorageKeys from './utils/localStorageKeys'
import {envConfig} from './utils/env'
import {initPromise} from './i18n'
import ContentLoader from './components/core/loader'

const App = () => {
    const customer = useSelector(state => state.sidebar.customer)
    const tawkMessengerRef = useRef()
    const [isReady, setIsReady] = useState(false)

    const prodEnv = 'prod'
    const {
        tawkPropId,
        tawkWidgetId,
        googleTagId,
        clarityId,
        appEnv
    } = envConfig

    document.documentElement.lang = localStorage.getItem(localStorageKeys.LANGUAGE)

    useEffect(() => {
        initPromise.then(() => setIsReady(true))
    }, [])

    useEffect(() => {
        const customerId = localStorage.getItem('customerId')

        if (customerId && !window.dataLayer && googleTagId) {
            TagManager.initialize({
                gtmId: googleTagId,
                dataLayer: {
                    userId: customerId
                }
            })
        }

        if (customerId && clarityId) {
            clarity.init(clarityId)
        }

        const onLoad = () => {
            tawkMessengerRef.current.visitor({
                name: CustomerHelper.getUserFullName(customer),
                email: customer?.email
            })
        }
        if (tawkMessengerRef.current) {
            onLoad()
        }
    }, [customer])

    return (
        <>
            {
                (Object.keys(customer).length !== 0 && appEnv === prodEnv && tawkPropId && tawkWidgetId) && (
                    <TawkMessengerReact
                        onLoad={() => {}}
                        propertyId={tawkPropId}
                        widgetId={tawkWidgetId}
                        ref={tawkMessengerRef}/>
                )
            }
            <BrowserRouter>
                {!isReady ? <ContentLoader/> :
                    <Suspense fallback={<ContentLoader/>}>
                        <Routes>
                            {routeArr.map((item, index) => (
                                (item.paths || []).map((path, idx) => (
                                    <Route
                                        key={`${index}-${idx}`}
                                        path={path}
                                        element={<MainLayout item={item} />}
                                    />
                                )
                                )
                            ))}
                        </Routes>
                    </Suspense>}
            </BrowserRouter>
        </>
    )
}

export default App
